/* eslint-disable react/prefer-stateless-function */

import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

class Notes extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
    this.divElement = React.createRef();
  }

  expandedText = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    let moreThanOneLine = 0;
    for (let i = 0; i < this.props.notes.length; i += 1) {
      if (this.props.notes.charCodeAt(i) === 10 || this.props.notes.charCodeAt(i) === 13 || this.props.notes.length > 100) {
        moreThanOneLine += 1;
      }
    }

    const { t } = this.props;
    return (
      <div className="client-profile-notes">
        {this.props.notes && (
          <div>
            <div className={this.state.expanded ? 'expandable-container open' : 'expandable-container '}>
              <span ref={this.divElement} className={this.state.expanded ? 'note-text' : 'note-text clip'}>
                {/* {this.state.height} */}
                {this.props.notes}
              </span>

              {moreThanOneLine > 1 ? (
                <span
                  role="button"
                  tabIndex={0}
                  className="show-more-text"
                  onClick={() => {
                    this.expandedText();
                  }}
                >
                  {this.state.expanded ? t('composite.clientProfile.details.lessNotes') : t('composite.clientProfile.details.moreNotes')}
                </span>
              ) : (
                <div />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const NotesHoc = withTranslation()(Notes);

export default NotesHoc;
